// Conta de serviço fixa do Traccar (TRACCAR_USER no .env do gpsdrive-backend
// — ver src/traccar/traccar.adapter.ts lá) usada por QUASE todo o backend
// pra falar com o Traccar (veículos, geofences, comandos, notificações,
// permissões, grants-sync). Não é uma pessoa: excluí-la ou editá-la pela
// tela de Usuários derrubaria integrações em cascata pelo sistema inteiro
// (pedido 2026-09-01: "deixar invisível... e nunca deixar ninguém excluir").
//
// A tela de Usuários (routes/users.tsx) lê e escreve direto no Traccar
// (GET/DELETE /api/users, ver services/users.service.ts) usando a sessão do
// próprio admin logado — não passa pelo gpsdrive-backend, então não há
// isolamento de empresa nem checagem alguma sobre QUAL usuário do Traccar
// está sendo listado/excluído. Este é o único ponto central de proteção do
// lado do app: filtra a conta da listagem (useUsers) e barra qualquer
// tentativa de exclusão (useDeleteUser) antes de a chamada sair pro Traccar.
//
// Isto NÃO impede alguém com credencial de administrador do Traccar de
// excluir a conta direto pela tela nativa do Traccar (api.gpsdrive.com.br/
// sem nenhum path — o Nginx expõe o app web do Traccar inteiro, não só a
// API REST) — essa é uma superfície fora do controle deste frontend.
export const PROTECTED_SERVICE_ACCOUNT_EMAIL = "gpsdrive@gmail.com";

export function isProtectedServiceAccount(email: string | null | undefined): boolean {
  return (email ?? "").trim().toLowerCase() === PROTECTED_SERVICE_ACCOUNT_EMAIL;
}
